module.exports = __webpack_public_path__ + "static/media/behandeling.6ddf6f11.svg";